function Footer() {
  return (
    <div
      style={{
        backgroundColor: "rgb(3, 72, 151)",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <p style={{ margin: "0px", color: "white" }}>
        Object Detection of Smart Vehicles © 2021/2022
      </p>
    </div>
  );
}

export default Footer;
